import CmsSlider from "../../componets/CmsSlider";
import brandsData from "../../data/plugAndAppDevelopmentBrands.json";

export default function Section6() {
  const settings = {
    touchMove: false,
    arrows: false,
    dots: true, // Enable dots for navigation
    infinite: false, // Infinite scroll for the slider
    slidesToShow: 4, // Show 5 slides at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: false, // Autoplay disabled
    cssEase: "linear", // Use linear transition for sliding
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          touchMove: true,
          infinite: true, // Infinite scroll for the slider
        },
      },
    ],
  };

  return (
    <div className="Section6">
      <div className="section6-container">
        <h2 className="leading-[29px] md:leading-[41px] text-center text-[24px] md:text-[34px] text-[#151515] font-bold my-[0.67em]">
          Brands That Choose Us
        </h2>

        <div className="w-full py-[1%] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]">
          <CmsSlider settings={settings} slides={brandsData} />
        </div>
      </div>
      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
